{
  "help": {
    "meta": {
      "title": "Help - MAJORITY",
      "description": "Do you have questions about MAJORITY? Our customer service team is here to help whenever you need it!"
    },
    "breadcrumb_labels": {
      "home": "Help center",
      "search_results": "Search Results"
    },
    "related_articles": "Related articles",
    "article_not_found": "Article not found",
    "article_not_found_message": "We couldn't find this article. Maybe you were looking for one of these articles:",
    "article_not_found_search_message": "We couldn't find this article. Try the search above to find what you were looking for.",
    "categories": "Categories",
    "explore_tutorials": "Explore our tutorials and see how easy it is to get things done with MAJORITY",
    "help_contact": {
      "title": "Contact us",
      "call_us": "Call us",
      "ask_us": "Ask us",
      "meetup_place": "Meetup place"
    },
    "meetup": {
      "address": "9801 V Bissonnet Street<br/>Houston, Texas"
    },
    "labels": {
      "search_placeholder": "Type in your search term…",
      "see_all": "See all",
      "watch_and_learn": "Watch and Learn"
    },
    "help_article": {
      "related_articles": "Related articles",
      "table_of_content": "Table of Content"
    },
    "help_contact_form": {
      "title": "We’re here to help",
      "description": "Please fill out the entire form so we can help you as quickly as possible. We usually respond within 5 hours!",
      "description_2": "If you’d prefer to write your own email, you can send it to <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a>.",
      "full_name_field": "Full name",
      "email_address_field": "Email address",
      "phone_number_field": "Phone number",
      "decription_field": "Describe what you need help with",
      "send_question": "Send question",
      "success_title": "Thank you for sharing your issue",
      "success_message": "We’ll do our best to help you within 24 hours, but please know that it may take us a bit longer during peak hours, holidays, and weekends.<br>We can’t wait to make your MAJORITY experience even better!<br><br>- The MAJORITY Team",
      "error_title": "Uh-oh, request not received",
      "error_message": "There seems to be a connection problem. Please try emailing <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a> instead.<br>We can’t wait to make your MAJORITY experience even better!<br><br>- The MAJORITY Team",
      "done": "Done"
    }}
  
}